import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import getUserRatingLabelIntlId from '@/scopes/common/components/utils/getUserRatingLabelIntlId'
import styles from './ReviewScore.module.css'
import { formatRating } from './utils'

interface ReviewScoreProps {
  rating: string
}

export function ReviewScore({ rating }: ReviewScoreProps) {
  const intl = useIntl()
  const scoreLabel = intl.formatMessage({ id: getUserRatingLabelIntlId(Number.parseFloat(rating)) })

  return (
    <div className={styles.wrapper}>
      <div className={styles.ratingBubble}>
        <Typography variant="body-s-bold-flat">{formatRating(rating)}</Typography>
      </div>
      <Typography variant="body-m-bold-tight">{scoreLabel}</Typography>
    </div>
  )
}
